import React from 'react';
import { NumericFormat } from 'react-number-format';
import PropTypes from 'prop-types';

const MoneyMask = React.forwardRef(function MoneyMask(
  { onChange, withPrefix = true, ...other },
  ref
) {
  return (
    <NumericFormat
      {...other}
      ref={ref}
      onValueChange={values => {
        onChange({
          target: {
            name: other.name,
            value: Number(values.value) || 0
          }
        });
      }}
      allowLeadingZeros
      thousandSeparator
      prefix={withPrefix ? '$ ' : ''}
    />
  );
});

export default MoneyMask;

MoneyMask.propTypes = {
  onChange: PropTypes.func.isRequired,
  withPrefix: PropTypes.bool
};
